<template>
  <section class="l-content">
    <el-card class="l-condition" name="hTable">
      <el-form :inline="true" :model="condition">
        <el-form-item label="所属企业" v-if="userInfo.eGroupCode">
          <l-select v-model="condition.enterpriseCode" :data="userInfo.eGroupChildren" :prop="['enterpriseCode', 'enterpriseName']" @change="getPageData"></l-select>
        </el-form-item>
        <el-form-item label="建议类型">
          <l-select v-model="condition.adviceType" :remote="$api.adviceType"></l-select>
        </el-form-item>
        <el-form-item label="建议分类">
          <l-select v-model="condition.adviceCategory" :remote="$api.adviceCategory"></l-select>
        </el-form-item>
        <el-form-item label="是否评价">
          <l-select v-model="condition.hasEvaluate" :data="$constant.adviceHasEvaluateList" @change="getPageData"></l-select>
        </el-form-item>
        <el-form-item label="提交部门">
          <l-select v-model="condition.createDepartId" :remote="$api.departList"></l-select>
        </el-form-item>
        <el-form-item label="实施部门">
          <l-select v-model="condition.effectDepartId" :remote="$api.departList"></l-select>
        </el-form-item>
        <el-form-item label="评价等级">
          <l-select v-model="condition.evaluateLevel" :remote="$api.adviceEvaluateLevel"></l-select>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <l-select v-model="condition.dateType" :all="false" :data="$constant.advice_dateType"></l-select>
          </template>
          <l-datepicker type="daterange" :default="[condition.startDate, condition.endDate]" @change="dataRangeChange"></l-datepicker>
        </el-form-item>
        <el-form-item>
          <el-input v-model="condition.keyword" size="small" width="300" placeholder="建议项目/员工名称"> </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider> </el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="adviceTitle" slot-scope="scope">
          <el-button type="text" @click="$site.view_advice_detail(scope.row.adviceId)">{{ scope.row.adviceTitle }}</el-button>
        </template>
        <template slot="adviceStatusName" slot-scope="scope">
          <span v-if="scope.row.adviceStatus == 0" class="text-grey">未提交</span>
          <span v-else-if="scope.row.adviceStatus == 1" class="text-blue">已提交</span>
          <span v-else-if="scope.row.adviceStatus == 10" class="text-green">已入围</span>
          <span v-else-if="scope.row.adviceStatus == 9" class="text-red">无效建议</span>
        </template>
        <template slot="effectStatusName" slot-scope="scope">
          <span v-if="scope.row.effectStatus == 0" class="text-grey">---</span>
          <span v-else-if="scope.row.effectStatus == 1" class="text-blue">实施中</span>
          <span v-else-if="scope.row.effectStatus == 2" class="text-green">已完成</span>
          <span v-else-if="scope.row.effectStatus == 8" class="text-red">无法实施</span>
          <span v-else-if="scope.row.effectStatus == 9" class="text-red">暂缓实施</span>
        </template>
        <template slot="evaluateTime" slot-scope="scope">
          <span v-if="scope.row.evaluateTime == null" class="text-grey">
            <el-button type="text" @click="doEvaluate(scope.row)"><span style="text-decoration: underline">未评价</span></el-button>
          </span>
          <span v-else class="text-green">{{ scope.row.evaluateLevel }}</span>
        </template>
        <template slot="evaluateMoney" slot-scope="scope">
          <span v-if="scope.row.evaluateTime == null" class="text-grey">---</span>
          <span v-else-if="scope.row.evaluateMoneyState == 0" class="text-cyan">
            {{ scope.row.evaluateMoney }}
            <el-button class="fr" type="text" @click="doMoney(scope.row)"><span style="text-decoration: underline">发放</span></el-button>
          </span>
          <span v-else-if="scope.row.evaluateMoneyState == 1" class="text-green">{{ scope.row.evaluateMoney }}</span>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import evaluateDo from './evaluate_do'
export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'AdviceList',
  data() {
    return {
      tableOption: {
        stripe: true,
        columns: [
          { label: '序号', type: 'index' },
          { label: '建议标题', slot: 'adviceTitle', overflow: true },
          { label: '建议类型', prop: 'adviceType', overflow: true },
          { label: '建议分类', prop: 'adviceCategory' },
          { label: '提交人', prop: 'createUserName' },
          { label: '实施人', prop: 'effectUserName' },
          { label: '提交时间', prop: 'submitTime', filter: (a, data) => this.$lgh.limitTo(a, 10) },
          { label: '实施日期', prop: 'effectTime', filter: (a, data) => this.$lgh.limitTo(a, 10) },
          { label: '建议状态', slot: 'adviceStatusName' },
          { label: '实施状态', slot: 'effectStatusName' },
          { label: '评价状态', slot: 'evaluateTime' },
          { label: '评价奖励', slot: 'evaluateMoney' }
        ]
      },
      condition: {
        enterpriseCode: '',
        departId: '',
        dateType: 'submitTime',
        startDate: '',
        endDate: '',
        keyword: '',
        hasEvaluate: '',
        evaluateLevel: '',
        adviceCategory: '',
        adviceType: '',
        adviceStatus: 10,
        effectStatus: 200,
        pageIndex: 1,
        pageSize: 10
      },
      pageData: null
    }
  },
  created() {
    this.condition.enterpriseCode = this.userInfo.enterpriseCode
    this.getPageData()
  },
  methods: {
    dataRangeChange(d1, d2) {
      this.condition.startDate = d1
      this.condition.endDate = d2
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/enterprise/advice/pagedlist', this.condition)
    },
    async doEvaluate(item) {
      await this.$lgh.openDialog({
        ins: evaluateDo,
        title: '建议评价',
        data: {
          dataInfo: Object.assign({}, item)
        }
      })
      this.$lgh.toastSuccess('评价完成')
      this.getPageData()
    },
    doMoney(item) {
      this.$lgh.msgConfirm('确认奖励已发放?', () => {
        this.$lgh.post('api/enterprise/advice/evaluate/money', item).then((res) => {
          this.$lgh.toastSuccess('操作成功')
          this.getPageData()
        })
      })
    }
  }
}
</script>
